import { Injectable } from "@angular/core";
import { AppConifgVM } from "../app-shared/model/app-config";
import { AppConfigHttpService } from "./app-config-http.service";
import { AppConfigDataService } from "./app-config-data-service";

@Injectable({providedIn:'root'})
export class AppConfigReloadService{
  readonly appConifg = 'appConfig';
  readonly mtrItems = 'mtrItems';
  readonly currentUser = 'currentUser';
  readonly menusAll = 'menusAll';
  readonly menuTitle = '';
  constructor(
    private httpSerivce: AppConfigHttpService,
    private dataService: AppConfigDataService

  ){}
  refreshCookies(){
    this.httpSerivce.getConfig().subscribe({
      next: (value: AppConifgVM | null)=>{
        if (value && value.msgItem?.isOK){
          if (value){
            this.dataService.saveConfigAll(value?.currentUser, value?.appConfig);
          }
        }
      }

    })
  }
}
